
import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { LorryGainLossReportFIN } from './Pages';

export const LorryGainLossReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={LorryGainLossReportFIN} />
    </Fragment>
)